import React from 'react';
import PropTypes from 'prop-types';
import {
  Components, Theme, Utils, translate,
} from 'versafleet-core';
import classNames from 'classnames';

class GlobalSearchItem extends React.Component {
  _renderEmptyItem() {
    return (
      <span className="vf-global-search__item__title">{this.props.strings.emptyItem}</span>
    );
  }

  _renderItem(data) {
    const recipientName = Utils.Helper.isNullOrUndefined(data.recipient_name)
      ? '' : `${this.props.strings.for} ${data.recipient_name} `;
    const customerName = Utils.Helper.isNullOrUndefined(data.customer)
      ? '' : `${this.props.strings.by} ${data.customer.name}`;
    const billingAccountName = Utils.Helper.isNullOrUndefined(data.billing_account)
      ? '' : `${this.props.strings.by} ${data.billing_account.name}`;

    return (
      <div
        className="vf-global-search__item__container"
        onClick={() => this.props.onClick(data)}
      >
        <Components.CircleIcon
          className="vf-global-search__item__icon"
          iconClassName={this.props.isJob
            ? `versa-base-${data.job_type}` : `versa-${data.job.job_type}`}
          innerIconColor={Theme.Color.$white}
          outerIconColor={Theme.Color.$blue}
        />

        <div className="vf-global-search__item__content">
          <div className="vf-global-search__item__content__title">
            {data.guid}
          </div>
          <div className="vf-global-search__item__content__sub-title">
            {this.props.isJob ? customerName : `${recipientName}${billingAccountName}`}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { data } = this.props;
    const className = classNames({
      'vf-global-search__item': true,
      'vf-global-search__item--no-item': Utils.Helper.isNullOrUndefined(data),
    });
    return (
      <div className={className}>
        {Utils.Helper.isNullOrUndefined(data) ? this._renderEmptyItem() : this._renderItem(data)}
      </div>
    );
  }
}

GlobalSearchItem.displayName = 'Global Search Item';

GlobalSearchItem.propTypes = {
  data: PropTypes.shape(),
  isJob: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  strings: PropTypes.shape().isRequired,
};

GlobalSearchItem.defaultProps = {
  data: null,
  isJob: false,
};

export default translate('GlobalSearch')(GlobalSearchItem);
